export const chunk = <T>(array: T[], size: number): T[][] => {
  if (size <= 0) throw new Error("Chunk size must be greater than 0")
  if (array.length === 0) return []
  return Array.from({ length: Math.ceil(array.length / size) }, (_, i) => {
    const start = i * size
    return array.slice(start, start + size)
  })
}
